export { formatError } from "helpers/formatError";

export const MAX_FIELD_ID_LENGTH = 50;

const SYMBOL_REPLACEMENTS = [
  [/#/g, " num "],
  [/\$/g, " dollars "],
  [/%/g, " percent "],
  [/&/g, " and "],
  [/@/g, " at "],
  [/\+/g, " plus "],
  [/\//g, " per "],
];

export const deriveFieldId = displayName => {
  if (!displayName) return "";
  let result = displayName;
  for (const [pattern, replacement] of SYMBOL_REPLACEMENTS) {
    result = result.replace(pattern, replacement);
  }
  return result
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
};

// Human-readable label for a row when its table has a display column set.
// Relationship cells contribute their enriched `__display` label, scalar
// cells their raw value. Null when unset or empty so callers can fall back
// to the table's singular name.
export const rowDisplayValue = (schema, row) => {
  const fieldId = schema?.display_field_id;
  if (!fieldId || !row) return null;
  const value = row[`${fieldId}__display`]?.label ?? row[fieldId];
  if (value == null || value === "") return null;
  return String(value);
};

export const deriveSingular = plural => {
  if (!plural) return "";
  const p = plural.trim();
  if (/ies$/i.test(p)) return p.replace(/ies$/i, "y");
  if (/sses$/i.test(p)) return p.replace(/es$/i, "");
  if (/s$/i.test(p) && !/ss$/i.test(p)) return p.replace(/s$/i, "");
  return p;
};
